import Client from "../client/ClientLeague"
const resource = "/api/v1"

const getRanking = (params) => {
  return Client.get(`${resource}/publish/leagues/ranking`, { params })
}
const getMatchOfLuague = (params) => {
  return Client.get(`${resource}/publish/leagues/match`, { params })
}
const userRepository = {
  getRanking,
  getMatchOfLuague
}

export default userRepository
